/**
 * V2I (Juli 2026) — zentrale Routingprüfung für automatische Owner-Navigation.
 *
 * Betreiberentscheidung (V2I): Eine `public-preview`-Session bleibt technisch
 * eine `owner_session` (V2H, Variante A/B), ist aber KEINE reguläre
 * Unternehmer-Session für automatische Dashboard-Weiterleitungen.
 *
 * Vertrag `isRegularOwnerSession(session)` → true NUR wenn:
 *   - session ein Objekt ist UND
 *   - tenant_id ein nicht-leerer String ist (fail-closed: ohne Tenantkennung
 *     kein automatischer /unternehmer-Redirect) UND
 *   - tenant_id !== "public-preview".
 *
 * AUTH-SICHERHEIT V2 · Phase 2 (Feb 2026): Der frühere zusätzliche Check
 * `typeof session.token === "string" && session.token !== ""` ist entfallen —
 * der Auth-Token wandert in ein httpOnly-Cookie und ist im JavaScript-Scope
 * nicht mehr sichtbar. `tenant_id` ist ab jetzt der maßgebliche Marker für
 * eine reguläre Owner-Session; der Serverseitig-Cookie ist die Auth-Wahrheit
 * (jeder API-Call schlägt bei ungültigem Cookie ohnehin mit 401 fehl). Die
 * Prüfung bleibt fail-closed: fehlt tenant_id, kein Redirect.
 *
 * Keine Seiteneffekte: kein Storage-Zugriff, keine Navigation, keine API.
 * Das Inline-Script der statischen Landingpage (public/landing/index.html)
 * kann dieses Modul nicht importieren und trägt eine exakt gleichlautende
 * minimale Prüfung (per CSP-Hash + Test `landingSessionCheck.test.js` gegen
 * Drift gesichert).
 */
export const PUBLIC_PREVIEW_TENANT_ID = "public-preview";

export function isRegularOwnerSession(session) {
  if (!session || typeof session !== "object") return false;
  if (typeof session.tenant_id !== "string" || session.tenant_id === "") return false;
  return session.tenant_id !== PUBLIC_PREVIEW_TENANT_ID;
}
